import React from "react";
import aboutImg from "../assets/img/coco12.png";
import { useDocument } from "../hooks/useDocument";

const DEFAULTS = {
  aboutSubtitle: "ส่งเสริมการอนุรักษ์และพัฒนาน้ำมันมะพร้าว",
  aboutHeading: "เรื่องราวจุดเริ่มต้นและวิสัยทัศน์",
  aboutParagraph1:
    "ชมรมอนุรักษ์และพัฒนาน้ำมันมะพร้าวแห่งประเทศไทย ก่อตั้งขึ้นด้วยความตั้งใจที่จะเผยแพร่และส่งเสริมการใช้ประโยชน์จากน้ำมันมะพร้าวในประเทศไทย โดยมุ่งหวังที่จะส่งเสริมการอนุรักษ์ เผยแพร่ความรู้และเทคโนโลยี รวมไปถึงสนับสนุนการวิจัยและพัฒนานวัตกรรมเพื่อเพิ่มมูลค่า พร้อมทั้งสร้างเครือข่ายความร่วมมือทั้งในและต่างประเทศ",
  aboutParagraph2:
    "ทางชมรมฯ มุ่งหวังที่จะสร้างอนาคตที่ยั่งยืนและเพิ่มโอกาสทางการค้าของน้ำมันมะพร้าวในตลาดโลก อีกทั้งสร้างความตระหนักรู้ถึงคุณค่าและประโยชน์ของน้ำมันมะพร้าวในชีวิตประจำวันของทุกคน",
  aboutFeature1Title: "ส่งเสริมการอนุรักษ์",
  aboutFeature1Desc:
    "ช่วยเพิ่มมูลค่าและสร้างโอกาสทางเศรษฐกิจให้กับเกษตรกรและผู้ผลิตในชุมชน เพื่อให้สามารถใช้ทรัพยากรในท้องถิ่นได้อย่างยั่งยืน",
  aboutFeature2Title: "สนับสนุนการวิจัยและนวัตกรรม",
  aboutFeature2Desc:
    "ส่งเสริมการวิจัยและพัฒนาเทคโนโลยีใหม่ ๆ ในการผลิตและการใช้ประโยชน์จากน้ำมันมะพร้าว เพื่อเพิ่มขีดความสามารถของผลิตภัณฑ์ในตลาดโลก",
};

const paraStyle = { fontSize: "23px", color: "#5a6570", textIndent: "2.5em" };
const descStyle = { fontSize: "23px", color: "#5a6570" };

const About = () => {
  const { data } = useDocument("settings", "site");
  const s = { ...DEFAULTS, ...(data || {}) };

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="section-title" data-aos="fade-up">
          <h2>About Us</h2>
          <p>{s.aboutSubtitle}</p>
        </div>
        <div className="row justify-content-between">
          <div className="col-lg-6 d-flex align-items-center justify-content-center about-img">
            <img src={aboutImg} className="img-fluid" alt="About" data-aos="zoom-in" />
          </div>

          <div className="col-lg-6 pt-5 pt-lg-0">
            <h3 data-aos="fade-up" data-aos-delay="40">{s.aboutHeading}</h3>
            <p data-aos="fade-up" data-aos-delay="90" style={paraStyle}>
              {s.aboutParagraph1}
            </p>
            <p data-aos="fade-up" data-aos-delay="100" style={{ ...paraStyle, marginTop: "0px" }}>
              {s.aboutParagraph2}
            </p>

            <div className="row">
              <div className="col-md-6" data-aos="fade-up" data-aos-delay="100">
                <i className="bx bx-receipt"></i>
                <h4>{s.aboutFeature1Title}</h4>
                <p style={descStyle}>{s.aboutFeature1Desc}</p>
              </div>
              <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                <i className="bx bx-cube-alt"></i>
                <h4>{s.aboutFeature2Title}</h4>
                <p style={descStyle}>{s.aboutFeature2Desc}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
